import AdminHeader from "components/Headers/AdminHeader";
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "constants/CommonConstants";
import { useNavigate } from "react-router-dom";

const initialSignatureList = [
  {
    id: 1,
    signatureName: "Director Signature",
    designation: "Director",
    authorizedPersonName: "Amit Sharma",
    document: {
      name: "Director Signature",
      url: require("assets/img/signatures/signature1.jpeg"),
    },
  },
  {
    id: 2,
    signatureName: "Training Head Signature",
    designation: "Training Head",
    authorizedPersonName: "Neha Patil",
    document: {
      name: "Training Head Signature",
      url: require("assets/img/signatures/signature1.jpeg"),
    },
  },
  {
    id: 3,
    signatureName: "HR Signature",
    designation: "HR Manager",
    authorizedPersonName: "Pooja Desai",
    document: {
      name: "HR Signature",
      url: require("assets/img/signatures/signature3.png"),
    },
  },
];

const Signatures = () => {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [data, setData] = useState(initialSignatureList);

  const handleEditClick = (e, row) => {
    e.stopPropagation();
    navigate(
      role === "SUPER_ADMIN"
        ? "/super-admin/signatures/add-new"
        : "/admin/signatures/add-new",
      {
        state: { mode: "edit" },
      },
    );
  };

  const handleAddSignatureClick = () => {
    navigate(
      role === "SUPER_ADMIN"
        ? "/super-admin/signatures/add-new"
        : "/admin/signatures/add-new",
    );
  };

  /* TABLE COLUMNS */
  const columns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Signature Name",
      accessor: "signatureName",
    },
    {
      Header: "Designation",
      accessor: "designation",
    },
    {
      Header: "Authorized Person Name",
      accessor: "authorizedPersonName",
    },
    {
      Header: "Document",
      accessor: "document",
      Cell: ({ value }) => {
        if (!value) return "-";
        const { name, url } = value;

        return (
          <span
            className="text-primary document-link"
            onClick={(e) => {
              e.stopPropagation();
              window.open(url, "_blank");
            }}
            title="Click to open document"
          >
            {name}
          </span>
        );
      },
    },

    {
      Header: "Action",
      disableSortBy: true,
      Cell: ({ row }) => {
        const id = row.original.id;
        return (
          <>
            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`edit${id}`}
              size="sm"
              onClick={(e) => handleEditClick(e, row)}
            >
              <i className="fa fa-edit mr-1 table-action-info" />
            </Button>
            <UncontrolledTooltip delay={0} target={`edit${id}`}>
              Edit
            </UncontrolledTooltip>
          </>
        );
      },
    },
  ];

  return (
    <>
      <AdminHeader />

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Signatures</h3>

                <Button
                  className="btn-deep-blue"
                  onClick={handleAddSignatureClick}
                >
                  <i className="fa fa-plus mr-1" />
                  Signature
                </Button>
              </CardHeader>

              <CardBody>
                <div className="mt-2 mb-3 mx-1">
                  <span className="total-certificate-records">
                    Total Records: {data.length}
                  </span>
                </div>

                <CommonTable
                  columns={columns}
                  data={data}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalRecords={data.length}
                  showPaginationBottom
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Signatures;
